export function createDataLayerObject(eventName, eventCategory, eventAction, customLabel) {
    var dataLayerObj = {
        'event': 'MinVilla_' + eventName,
        'eventCategory': eventCategory,
        'eventAction': eventAction,
    };
    if (customLabel) {
        dataLayerObj['eventLabel'] = customLabel;
    }
    return dataLayerObj;
}
export function dataLayerCustomLabelFormTracker(formId, eventCategory, eventName, eventAction) {
    var $form = $('#' + formId).first();
    var customLabel = $form.data('label-name');
    if ($form.length < 1) {
        return;
    }
    if (!$form.is('form')) {
        return;
    }
    $form.submit(function () {
        var dataLayerObj = createDataLayerObject(eventName, eventCategory, eventAction, customLabel);
        window['dataLayer'].push(dataLayerObj);
    });
}
export function dataLayerCardTracker(className, eventCategory, eventName, eventAction) {
    var teasers = $('.' + className);
    if (teasers.length < 1) {
        return;
    }
    if (!teasers.is('div')) {
        return;
    }
    teasers.each(function (index, teaser) {
        var $teaser = $(teaser);
        var customLabel = $teaser.data('label-name');
        $teaser.click(function () {
            var dataLayerObj = createDataLayerObject(eventName, eventCategory, eventAction, customLabel);
            window['dataLayer'].push(dataLayerObj);
        });
    });
}
